import type { InputHTMLAttributes } from "react";
import { cn } from "../lib/cn";

export function TextInput({
  className,
  "data-invalid": dataInvalid,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & {
  "data-invalid"?: boolean;
}) {
  return (
    <input
      className={cn("cf-input", className)}
      data-invalid={dataInvalid || undefined}
      aria-invalid={dataInvalid || undefined}
      {...props}
    />
  );
}
